import { CalendarDate } from '@internationalized/date';
import { TruckStatus } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateTruckMutation = createMutationHook(
  'transportation.truckUpdate',
  (params: {
    id: string;
    status?: TruckStatus;
    licensePlate?: string;
    licensePlateExpiration?: CalendarDate;
    vin?: string;
    model?: string;
    capacity?: number;
    country?: string;
    state?: string;
    notes?: string;
    transportationTypeId?: string;
    defaultTrailerId?: string;
  }) => ({
    transportationTruckUpdate: {
      __args: {
        id: params.id,
        input: {
          status: params.status,
          licensePlate: params.licensePlate,
          licensePlateExpiration: params.licensePlateExpiration
            ?.toDate('UTC')
            .toISOString(),
          vin: params.vin,
          model: params.model,
          capacity: params.capacity,
          country: params.country,
          state: params.state,
          notes: params.notes,
          transportationTypeId: params.transportationTypeId,
          defaultTrailerId: params.defaultTrailerId,
        },
      },
      id: true,
      status: true,
      licensePlate: true,
      model: true,
      transportationType: {
        id: true,
        name: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
